import { Transforms, Editor, Range, Element } from 'slate'

import { isBlockTypeActive } from './isBlockTypeActive.js'
import { isInlineCheckboxFeasible } from './isInlineCheckboxFeasible.js'

export function insertInlineCheckbox (editor) {
  const { selection } = editor
  if (!selection) {
    return
  }

  const isFeasible = isInlineCheckboxFeasible(editor)
  if (!isFeasible) {
    return
  }

  const isActive = isBlockTypeActive(editor, 'checkbox')

  if (isActive) {
    Transforms.unwrapNodes(editor, {
      match: node => (
        !Editor.isEditor(node) &&
        Element.isElement(node) &&
        node.type === 'checkbox'
      )
    })

    return
  }

  const isCollapsed = Range.isCollapsed(selection)

  const node = {
    type: 'checkbox',
    isChecked: false,
    children: isCollapsed
      ? [{
        text: 'Checkbox'
      }]
      : []
  }

  if (isCollapsed) {
    Transforms.insertNodes(editor, node)
    return
  }

  Transforms.wrapNodes(editor, node, { split: true })
  Transforms.collapse(editor, { edge: 'end' })
}
